import {useEffect, useState, useSyncExternalStore} from "react";

const useVisibilityChangeSubscribe = (callback: () => void) => {
  document.addEventListener("visibilitychange", callback);
  return () => {
    document.removeEventListener("visibilitychange", callback);
  };
};

const getVisibilityChangeSnapshot = () => {
  return document.visibilityState;
};

const useVisibilityChange = () => {
  const visibilityState = useSyncExternalStore(
    useVisibilityChangeSubscribe,
    getVisibilityChangeSnapshot
  );

  return visibilityState === "visible";
};

const ActiveLock = () => {
  useEffect(() => {
    let wakeLock: WakeLockSentinel | null = null;
    let unmounted = false;
    const doIt = async () => {
      try {
        const response = await navigator.wakeLock.request("screen");
        if (unmounted) {
          void response.release();
        } else {
          wakeLock = response;
        }
      } catch (e) {
        console.warn(e);
      }
    };
    void doIt();
    return () => {
      unmounted = true;
      if (wakeLock) void wakeLock.release();
    };
  }, []);

  return null;
};

const WakeLock = () => {
  const [supported] = useState("wakeLock" in navigator);
  const visible = useVisibilityChange();
  return supported && visible ? <ActiveLock /> : null;
};

export default WakeLock;
